import React from 'react';
import { Input, Tag } from 'rsuite';
import { Button } from '@urbantxt/button';
import type { BagelFlowTestResult } from '../../types/aiFlow';
import styles from './AiFlowTab.module.scss';

type Props = {
  text: string;
  onTextChange: (value: string) => void;
  onRun: () => void;
  running: boolean;
  result: BagelFlowTestResult | null;
  error: string | null;
};

export default function AiFlowTestBox({
  text,
  onTextChange,
  onRun,
  running,
  result,
  error,
}: Props) {
  return (
    <div className={styles.testBox}>
      <div className={styles.testRow}>
        <Input
          as="textarea"
          rows={2}
          value={text}
          placeholder="Type a sample Slack message to test routing…"
          onChange={value => onTextChange(String(value))}
          className={styles.testInput}
        />
        <Button
          appearance="primary"
          onClick={onRun}
          loading={running}
          disabled={!text.trim() || running}
        >
          Run
        </Button>
      </div>
      {error ? (
        <p className={styles.testError}>{error}</p>
      ) : null}
      {result ? (
        <div className={styles.testResult}>
          <Tag color="blue">Skill: {result.skill}</Tag>
          {result.confidence != null ? (
            <Tag>{`Confidence: ${(result.confidence * 100).toFixed(0)}%`}</Tag>
          ) : null}
          {result.usedRegexFallback ? (
            <Tag color="orange">Regex fallback</Tag>
          ) : null}
          {result.needsConfirmation ? (
            <Tag color="yellow">Needs confirmation</Tag>
          ) : null}
          {result.projectNameHint ? (
            <Tag>{`Project: ${result.projectNameHint}`}</Tag>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
